import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import {
  setHertzLoyaltyRewardsNumber,
  setPendingLoyaltySync,
  updateUserPassenger,
} from "../../actions/actions";
import { IStoreState } from "../../../../reducers/types";
import { HertzLoyaltyForm } from "./component";
import {
  getConfirmationDetailsError,
  getHertzLoyaltyRewardsNumber,
  getPendingLoyaltySync,
  getPollPriceQuoteCallState,
  getPriceQuoteErrors,
  getUseV1PurchaseFlow,
  getUserPassengerCallState,
  getSelectedDriver,
} from "../../reducer";
import { getCarShopSelectedVehicle } from "../../../shop/reducer";
import { getHertzTierStatus } from "../../../rewards/reducer";

const mapStateToProps = (state: IStoreState) => ({
  hertzLoyaltyRewardsNumber: getHertzLoyaltyRewardsNumber(state),
  priceQuoteErrors: getPriceQuoteErrors(state),
  confirmationDetailsErrors: getConfirmationDetailsError(state),
  selectedVehicle: getCarShopSelectedVehicle(state),
  useV1PurchaseFlow: getUseV1PurchaseFlow(state),
  selectedDriver: getSelectedDriver(state),
  hertzTierStatus: getHertzTierStatus(state),
  pollPriceQuoteCallState: getPollPriceQuoteCallState(state),
  userPassengerCallState: getUserPassengerCallState(state),
  pendingLoyaltySync: getPendingLoyaltySync(state),
});

const mapDispatchToProps = {
  setHertzLoyaltyRewardsNumber,
  updateUserPassenger,
  setPendingLoyaltySync,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type HertzLoyaltyFormConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedHertzLoyaltyForm = withRouter(
  connector(HertzLoyaltyForm)
);